import { supabase } from "../../Services/supabaseClient";

export const getCollections = async (companyId) => {
  const { data, error } = await supabase
    .from("crm_collections")
    .select(
      `
      *,
      crm_accounts(id, name)
    `
    )
    .eq("company_id", companyId)
    .order("created_at", { ascending: false });

  if (error) throw error;
  return data || [];
};

export const createCollectionCase = async (payload) => {
  const { data, error } = await supabase
    .from("crm_collections")
    .insert([payload])
    .select()
    .single();

  if (error) throw error;
  return data;
};

export const updateCollectionCase = async (
  collectionId,
  companyId,
  payload
) => {
  const { data, error } = await supabase
    .from("crm_collections")
    .update(payload)
    .eq("id", collectionId)
    .eq("company_id", companyId)
    .select()
    .single();

  if (error) throw error;
  return data;
};

export const createCollectionFromInvoice = async ({
  companyId,
  accountId,
  invoiceId,
  assignedTo,
  note,
  nextFollowUpAt,
}) => {
  const { data: existingRows, error: existingError } = await supabase
    .from("crm_collections")
    .select("id")
    .eq("company_id", companyId)
    .eq("invoice_id", invoiceId)
    .limit(1);

  if (existingError) throw existingError;

  if ((existingRows || []).length > 0) {
    return existingRows[0];
  }

  const { data, error } = await supabase
    .from("crm_collections")
    .insert([
      {
        company_id: companyId,
        account_id: accountId,
        invoice_id: invoiceId,
        assigned_to: assignedTo,
        note,
        next_follow_up_at: nextFollowUpAt,
      },
    ])
    .select()
    .single();

  if (error) throw error;
  return data;
};
